import styled from '@emotion/styled';
import { BuildingPermitTableColumn } from '../utils';

export const BuildingPermitColumn = styled.div<{ col?: BuildingPermitTableColumn }>`
  & > div {
    color: ${({ theme }) => theme.colors.neutrals.grey3};
  }
  ${({ col, theme }) => col === BuildingPermitTableColumn.RequestedChange ? `
    display: flex;
    & > div:nth-of-type(1) {
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 160px;
    }
    & > div:nth-of-type(2) {
      border-radius: ${theme.spacing(0.5)};
      padding: 2px ${theme.spacing(0.5)};
      align-self: center;
      background-color: ${theme.colors.neutrals.grey9};
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(1)};
    }
  ` : ''}
  ${({ col, theme }) => col === BuildingPermitTableColumn.RequestedChange ? theme.media.showAt({ to: 1 })`
    flex-direction: column;
    & > div:nth-of-type(1) {
      color: ${theme.colors.neutrals.grey1};
    }
    & > div:nth-of-type(2) {
      align-self: flex-start;
      margin: ${theme.spacing(1)} 0 0;
    }
  ` : ''}
  ${({ col, theme }) => col === BuildingPermitTableColumn.LastEventDate ? theme.media.showAt({ to: 1 })`
    display: flex;
    flex-direction: column;
    & > div:nth-of-type(1) {
      color: ${theme.colors.neutrals.grey1};
    }
    & > div:nth-of-type(2) {
      margin-top: ${theme.spacing(1)};
      color: ${theme.colors.neutrals.grey3};
    }
  ` : ''}
}`;
